import { SearchCreditsRes_Result } from "gen/search/service/service_pb"
import {
  CreditAllocationStatus,
  Receivable_Transaction_Type as RecvTxnType,
} from "gen/txn/models_pb"
import { FieldMapping, mapFields } from "shared-ts/adapters"
import { BaseReceivable, getReceivableMapping } from "shared-ts/receivables"
import { ensure } from "shared-ts/utils"

export interface CreditReceivable extends BaseReceivable {
  status: CreditAllocationStatus
  receivableTxnType: RecvTxnType
}

const searchCreditsTableItemMapping: FieldMapping<
  SearchCreditsRes_Result,
  CreditReceivable
> = {
  ...getReceivableMapping(),
  status: (res) => res.allocationStatus,
  receivableTxnType: (res) =>
    ensure(
      res.receivable?.transaction?.type,
      "Missing receivable.transaction.type"
    ),
}

export function adaptSearchCreditsResultToCreditTableItems(
  results: SearchCreditsRes_Result[] = []
): CreditReceivable[] {
  const items: CreditReceivable[] = []
  for (const result of results) {
    const { data, errors } = mapFields(result, searchCreditsTableItemMapping)
    if (!errors) {
      items.push(data)
    }
  }
  return items
}
